import createLucideIcon from '../createLucideIcon';

const BookX = createLucideIcon('BookX', [
  ['path', { d: 'M9.5,7l5,5', key: '8j6b4e' }],
  ['path', { d: 'M14.5,7l-5,5', key: '15tkdz' }],
  ['path', { d: 'M4 19.5A2.5 2.5 0 0 1 6.5 17H20', key: '126fyg' }],
  [
    'path',
    {
      d: 'M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z',
      key: '1msh16',
    },
  ],
]);

export default BookX;
